import { PageContainer } from '@ant-design/pro-components';
import { history } from '@umijs/max';
import { Button, Empty, Space, Spin } from 'antd';
import React from 'react';
import { useParkContext } from './context';
import { APPLICATIONS_NEW_PATH, isParkScopedPath } from './scope';

export const ParkRequiredEmpty: React.FC = () => (
  <PageContainer breadcrumb={{ items: [] }}>
    <Empty description="当前暂无可用园区，请先完成入驻。">
      <Button
        type="primary"
        onClick={() => history.push(APPLICATIONS_NEW_PATH)}
      >
        申请入驻
      </Button>
    </Empty>
  </PageContainer>
);

export const ParkSelectEmpty: React.FC = () => {
  const { parks, setParkUuid } = useParkContext();
  return (
    <PageContainer breadcrumb={{ items: [] }}>
      <Empty description="请选择当前园区">
        <Space direction="vertical">
          {parks.map((park) => (
            <Button
              key={park.uuid}
              type="primary"
              onClick={() => setParkUuid(park.uuid)}
            >
              {park.name}
            </Button>
          ))}
        </Space>
      </Empty>
    </PageContainer>
  );
};

export const ParkScopeGate: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [pathname, setPathname] = React.useState(
    () => history.location.pathname,
  );
  const { hasActivePark, parkUuid, parks, loading } = useParkContext();

  React.useEffect(
    () =>
      history.listen(({ location }) => {
        setPathname(location.pathname);
      }),
    [],
  );

  if (!isParkScopedPath(pathname)) {
    return children;
  }
  if (loading) {
    return (
      <PageContainer breadcrumb={{ items: [] }}>
        <Spin description="正在加载园区" />
      </PageContainer>
    );
  }
  if (parks.length > 0 && !parkUuid) {
    return <ParkSelectEmpty />;
  }
  if (!hasActivePark) {
    return <ParkRequiredEmpty />;
  }
  return <React.Fragment key={parkUuid}>{children}</React.Fragment>;
};
